import Vue from "vue";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";

import i18n from "@/lang/index";

Vue.use(ViewUI, {
  i18n: (key, value) => {
    return i18n.t(key, value);
  },
});
